import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'initials',
})
export class InitialsPipe implements PipeTransform {
  transform(name: string | null | undefined, maxLength = 2): string {
    if (!name) return '';

    const parts = name.trim().split(/\s+/);
    if (parts.length === 1) {
      return parts[0].substring(0, maxLength).toUpperCase();
    }

    const initials = parts
      .slice(0, maxLength)
      .map((part) => part[0])
      .join('');

    return initials.toUpperCase();
  }
}
